import { render, staticRenderFns } from "./flickering-word.vue?vue&type=template&id=c10b010e"
import script from "./flickering-word.vue?vue&type=script&lang=js"
export * from "./flickering-word.vue?vue&type=script&lang=js"
import style0 from "./flickering-word.vue?vue&type=style&index=0&id=c10b010e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports